export function isPresent(value: any): boolean {
    return (value !== undefined && value !== null);
}

export function propertyToLowerCase(object: any, propertyName: string) {
    const propertyValue = object[propertyName];

    if (propertyValue !== undefined) {
        if (typeof propertyValue === "string") {
            return propertyValue.toLowerCase();
        }

        return propertyValue;
    }

    return undefined;
}

export function toLocaleString(value: number): string {
    if (value === 0) {
        return value.toString();
    }

    return value.toLocaleString();
}